export enum TimeBlockEvents {
    CreateFormModelDidUpdate = 'TimeBlock.Create.FormModelDidUpdate',
    EditFormModelDidUpdate = 'TimeBlock.Edit.FormModelDidUpdate',
}